import { render, staticRenderFns } from "./RecipeImport.vue?vue&type=template&id=8a09e61a&scoped=true"
import script from "./RecipeImport.vue?vue&type=script&lang=js"
export * from "./RecipeImport.vue?vue&type=script&lang=js"
import style0 from "./RecipeImport.vue?vue&type=style&index=0&id=8a09e61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a09e61a",
  null
  
)

export default component.exports